import React from 'react'
import Inner from '../component/Innerbanner' // Assuming Innerbanner is in this location

// A helper component to create styled sections
const PolicySection = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-2xl font-bold text-gray-900 mb-4">{title}</h2>
    <div className="space-y-4 text-gray-500">
      {children}
    </div>
  </div>
);

// A helper component for list items
const ListItem = ({ children }) => (
  <li className="ml-5 list-disc">{children}</li>
);

function TermsCondition() {
  return (
    <div className="font-custom">
      <Inner name="Terms & Conditions" title="Home . TERMS OF USE" />

      {/* --- Terms and Conditions Content --- */}
      <div className="bg-white py-16 sm:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">

          <PolicySection title="Agreement and Modifications">
            <p>
              By accessing and using this website, you agree to be bound by these **Terms of Use** and all policies referenced herein. We reserve the right to change or modify these terms at any time without prior notice. **Any use of the site by you after such notice shall be interpreted as acceptance by you of such changes or modifications.**
            </p>
          </PolicySection>
          
          <hr className="border-t-2 border-teal-200 my-8" />

          <PolicySection title="User Provided Artwork and Images (Intellectual Property)">
            <p className='font-bold text-gray-700'>
              You are responsible for all uploaded content.
            </p>
            <p>
              You represent and warrant that you have the **right to use, copy, and distribute** each copyright, trademark, service mark, logo, or other intellectual property in the way it is to be printed.
            </p>
            <ul>
              <ListItem>
                You warrant that by submitting material for reproduction, you have not violated the **property rights of any third party**.
              </ListItem>
              <ListItem>
                The burden of determining that any material is not protected by copyright or trademark rests **solely with you**.
              </ListItem>
              <ListItem>
                You agree to **indemnify and hold us harmless** against any claims, losses, or liabilities arising from the breach of this warranty or the unauthorized use of any logo or trademark.
              </ListItem>
              <ListItem>
                You may not use any logo or trademark in a **vulgar, libelous, disparaging, or otherwise unlawful manner**.
              </ListItem>
            </ul>
          </PolicySection>
          
          <hr className="border-t-2 border-teal-200 my-8" />

          <PolicySection title="Clip Art Usage">
            <p>
              All clip art images provided on the site are the property of the company or are licensed from third-party vendors.
            </p>
            <p>
              **Designs created by users from the provided clip art are in no way the exclusive property of those users or customers** who assemble such designs.
            </p>
          </PolicySection>

          <PolicySection title="Accuracy of Colors and Graphics">
            <p>
              We have displayed as accurately as possible the colors and graphics of the products that appear on the site. However:
            </p>
            <ul>
              <ListItem>
                We **cannot guarantee that your monitor's display of any color will be accurate**, as colors depend on your monitor settings.
              </ListItem>
              <ListItem>
                The colors shown are for **reference only** and may be slightly different from the actual colors of the finished product.
              </ListItem>
              <ListItem>
                We will have **no liability** for damages or returns resulting from variances between the appearance of colors on your monitor and the finished product.
              </ListItem>
            </ul>
          </PolicySection>

          <PolicySection title="Privacy Commitment">
            <p>
              As a user, you acknowledge that you may provide information regarding yourself, including your name, address, and email address. We are committed to protecting your privacy.
            </p>
            <p>
              Any information that we collect about you will **not be used outside our company without your notification and permission**. We do not buy, sell, rent, lease, or share email addresses and other personal information in any way.
            </p>
          </PolicySection>

        </div>
      </div>
    </div>
  )
}

export default TermsCondition